// Cashier branch-change workflow (working hours / maintenance closure).
// Server: /api/auth/branch-requests. Every permission and state check is the
// server's; the client only shows what it is told it may do (`workflow.can`).
import config from "../../config.json";

const BASE = `${config.BASE_AUTH_API}branch-requests`;

export class BranchRequestError extends Error {
  constructor(message, { status = 0, code = null, details = null } = {}) {
    super(message);
    this.name = "BranchRequestError";
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

async function call(path, token, { method = "GET", body, signal } = {}) {
  let response;
  try {
    response = await fetch(`${BASE}${path}`, {
      method,
      headers: { Accept: "application/json", Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}),
      signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    throw new BranchRequestError("Network error", { code: "NETWORK" });
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new BranchRequestError(data.message || "Request failed", { status: response.status, code: data.code || null, details: data.details || null });
  }
  return data;
}

const enc = encodeURIComponent;

export const getBranchWorkflowAPI = (token, id, options) => call(`/${enc(id)}`, token, options).then((data) => data.workflow);
export const reviewBranchRequestAPI = (token, id, { decision, reason = "", note = "" }) =>
  call(`/${enc(id)}/review`, token, { method: "POST", body: { decision, reason, note, confirm: true } }).then((data) => data.workflow);
export const confirmBranchApplicationAPI = (token, id, application, { note = "", reference = "" } = {}) =>
  call(`/${enc(id)}/applications/${enc(application)}/confirm`, token, { method: "POST", body: { note, reference, confirm: true } }).then((data) => data.workflow);
export const finalizeBranchRequestAPI = (token, id, { override = false, reason = "" } = {}) =>
  call(`/${enc(id)}/finalize`, token, { method: "POST", body: { override, reason, confirm: true } }).then((data) => data.workflow);
